import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
const paynowClauseKeys = {
    all: ['paynowClauses'],
    get: (filter) => ['paynowClauses', 'list', filter],
};
export const paynowClauseOptions = {
    get: (filter) => queryOptions({
        queryKey: paynowClauseKeys.get(filter),
        queryFn: async () => {
            const repository = await resolveRepository(Domain.PaynowClause);
            return repository.get(filter);
        },
        staleTime: Infinity,
    }),
};
